import { useEffect, useRef } from 'react';
import { Turnstile } from '@marsidev/react-turnstile';
import dropClient from '../state/dropClient.js';

// Cloudflare Turnstile widget. Feeds tokens to the drop client so the connected
// address can be verified (siteverify, server-side) before it becomes eligible
// for the midnight token drop. Defaults to Cloudflare's "always passes" TEST
// site key; set VITE_TURNSTILE_SITE_KEY to the real one in production.
const SITE_KEY = import.meta.env.VITE_TURNSTILE_SITE_KEY || '1x00000000000000000000AA';

export default function TurnstileGate() {
  const ref = useRef(null);

  useEffect(() => {
    // Let the drop client ask for a fresh token (e.g. after a reconnect or a
    // rejected/expired token), since Turnstile tokens are single-use.
    dropClient.onNeedToken = () => ref.current?.reset();
    return () => {
      dropClient.onNeedToken = null;
    };
  }, []);

  return (
    <Turnstile
      ref={ref}
      siteKey={SITE_KEY}
      onSuccess={(token) => dropClient.setTurnstileToken(token)}
      onExpire={() => ref.current?.reset()}
      onError={() => dropClient.setTurnstileToken(null)}
      // interaction-only: stays invisible while it can solve silently (the common
      // case), so this can mount app-wide; only renders UI if a challenge is needed.
      options={{ theme: 'auto', refreshExpired: 'auto', appearance: 'interaction-only' }}
    />
  );
}
